import React from "react"
import { Chip, Stack, Theme } from "@carrotfertility/carotene-core"
import { ChipType, ChipWithTooltip } from "./Chip"

interface PlanTagsProps {
  journeyChanged?: boolean
  isCheckedIn?: boolean
  isSensitiveScenario?: boolean
  allMedicalQuestionsSkipped?: boolean
  isRequestNewerThanActiveCarrotPlan?: boolean
  isNoCarrotPlanNeeded?: boolean
  isRepublished?: boolean
}

export const PlanTags = ({
  journeyChanged,
  isCheckedIn,
  isSensitiveScenario,
  allMedicalQuestionsSkipped,
  isRequestNewerThanActiveCarrotPlan,
  isNoCarrotPlanNeeded,
  isRepublished
}: PlanTagsProps): JSX.Element => {
  const showNoPlan = isRequestNewerThanActiveCarrotPlan && !isNoCarrotPlanNeeded

  return (
    <Stack
      alignItems={"flex-start"}
      justifyContent="flex-start"
      direction="column"
      gap={(theme) => theme.spacing(theme.tokens.spacing.xs)}
    >
      {isRepublished && <Chip label={ChipType.REPUBLISHED} />}
      {journeyChanged && <Chip color="warning" label={ChipType.CHANGED_JOURNEY} />}
      {isCheckedIn && (
        <ChipWithTooltip type={ChipType.CHECKED_IN} backgroundColor={(theme: Theme) => theme.palette.primary.light} />
      )}
      {isSensitiveScenario && (
        <ChipWithTooltip
          type={ChipType.SENSITIVE_SCENARIO}
          backgroundColor={(theme: Theme) => theme.palette.background.hover}
        />
      )}
      {allMedicalQuestionsSkipped && <Chip label={ChipType.SKIPPED_MEDICAL_QUESTIONS} />}
      {showNoPlan && (
        <ChipWithTooltip type={ChipType.NO_PLAN} backgroundColor={(theme: Theme) => theme.palette.success.light} />
      )}
      {isNoCarrotPlanNeeded && (
        <ChipWithTooltip type={ChipType.NO_PLAN_NEEDED} backgroundColor={(theme: Theme) => theme.palette.error.light} />
      )}
    </Stack>
  )
}
